export default __webpack_public_path__ + "static/media/product1.36682246.jpg";